import { getDistChannel } from "../../../../actions/Utilities/Common";
import { useQuery } from "react-query";

export const useDistributionChannelOptions = () => {
  return useQuery("DistributionChannelProducerCode", getDistChannel, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
